import { render } from "./appContent.vue?vue&type=template&id=72763dee&scoped=true"
import script from "./appContent.vue?vue&type=script&lang=js"
export * from "./appContent.vue?vue&type=script&lang=js"

import "./appContent.vue?vue&type=style&index=0&id=72763dee&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72763dee"]])

export default __exports__